import axios from 'axios'
import { store } from '@/store/index'

axios.interceptors.response.use(
  response => {
    if (response.data instanceof Blob) {
      return response
    }

    const responseDataErrorType = parseInt(response.data?.error?.type)
    if (isNaN(responseDataErrorType) || responseDataErrorType === 200) {
      return response
    }

    const errmsg = response.data?.error?.message || 'The error has occurred during execution of the operation.'

    if (responseDataErrorType === 402) {
      store.commit('user/set', { type: 'unpaidError', val: true })
      store.dispatch('showUpgradeSubscriptionPlanPopup', { title: response.data?.error?.message })
    }
    store.dispatch('showSubmitFormErrorPopup', { title: 'Error', message: errmsg })

    return response
  },
  error => {
    if (error.response.status === 401) {
      localStorage.setItem('redirectAfterAuthorization', window.location.href)
      window.location = '/login'
    } else {
      return Promise.reject(error)
    }
  }
)

export default axios
